import { render } from "./ToggleWithTitle.vue?vue&type=template&id=6bec49f6&scoped=true"
import script from "./ToggleWithTitle.vue?vue&type=script&lang=js"
export * from "./ToggleWithTitle.vue?vue&type=script&lang=js"

import "./ToggleWithTitle.vue?vue&type=style&index=0&id=6bec49f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bec49f6"]])

export default __exports__